// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as HowItWorksRouteImport } from './routes/how-it-works'
import { Route as HistoryRouteImport } from './routes/history'
import { Route as HelpCenterRouteImport } from './routes/help-center'
import { Route as DevboxRouteImport } from './routes/devbox'
import { Route as BattlesRouteImport } from './routes/battles'
import { Route as AccountTypesRouteImport } from './routes/account-types'
import { Route as AboutRouteImport } from './routes/about'
import { Route as IndexRouteImport } from './routes/index'
import { Route as CallbacksPaymentRouteImport } from './routes/callbacks.payment'
import { Route as BattleIdRouteImport } from './routes/battle.$id'
import { Route as AuthSignupRouteImport } from './routes/auth.signup'
import { Route as AuthResetPasswordRouteImport } from './routes/auth.reset-password'
import { Route as AuthLoginRouteImport } from './routes/auth.login'
import { Route as SettingsProfileRouteImport } from './routes/settings.profile'
import { Route as SettingsPasswordRouteImport } from './routes/settings.password'
import { Route as SettingsNotificationsRouteImport } from './routes/settings.notifications'
import { Route as SettingsEarningsRouteImport } from './routes/settings.earnings'
import { Route as SettingsDashboardRouteImport } from './routes/settings.dashboard'
import { Route as SettingsBillingHistoryRouteImport } from './routes/settings.billing-history'
import { Route as SettingsBattlesRouteImport } from './routes/settings.battles'
import { Route as BattleIdBidsRouteImport } from './routes/battle_.$id.bids'
import { Route as BattleIdDetailsRouteImport } from './routes/battle.$id.details'
import { Route as BattleIdBattleRouteImport } from './routes/battle.$id.battle'
import { Route as SettingsNotificationsPreferencesRouteImport } from './routes/settings.notifications_.preferences'

const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const SettingsRoute = SettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => rootRouteImport
          })
const HowItWorksRoute = HowItWorksRouteImport.update({
            id: '/how-it-works',path: '/how-it-works',getParentRoute: () => rootRouteImport
          })
const HistoryRoute = HistoryRouteImport.update({
            id: '/history',path: '/history',getParentRoute: () => rootRouteImport
          })
const HelpCenterRoute = HelpCenterRouteImport.update({
            id: '/help-center',path: '/help-center',getParentRoute: () => rootRouteImport
          })
const DevboxRoute = DevboxRouteImport.update({
            id: '/devbox',path: '/devbox',getParentRoute: () => rootRouteImport
          }).lazy(() => import('./routes/devbox.lazy').then((d) => d.Route))
const BattlesRoute = BattlesRouteImport.update({
            id: '/battles',path: '/battles',getParentRoute: () => rootRouteImport
          })
const AccountTypesRoute = AccountTypesRouteImport.update({
            id: '/account-types',path: '/account-types',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const CallbacksPaymentRoute = CallbacksPaymentRouteImport.update({
            id: '/callbacks/payment',path: '/callbacks/payment',getParentRoute: () => rootRouteImport
          })
const BattleIdRoute = BattleIdRouteImport.update({
            id: '/battle/$id',path: '/battle/$id',getParentRoute: () => rootRouteImport
          })
const AuthSignupRoute = AuthSignupRouteImport.update({
            id: '/auth/signup',path: '/auth/signup',getParentRoute: () => rootRouteImport
          })
const AuthResetPasswordRoute = AuthResetPasswordRouteImport.update({
            id: '/auth/reset-password',path: '/auth/reset-password',getParentRoute: () => rootRouteImport
          })
const AuthLoginRoute = AuthLoginRouteImport.update({
            id: '/auth/login',path: '/auth/login',getParentRoute: () => rootRouteImport
          })
const SettingsProfileRoute = SettingsProfileRouteImport.update({
            id: '/profile',path: '/profile',getParentRoute: () => SettingsRoute
          }).lazy(() => import('./routes/settings.profile.lazy').then((d) => d.Route))
const SettingsPasswordRoute = SettingsPasswordRouteImport.update({
            id: '/password',path: '/password',getParentRoute: () => SettingsRoute
          })
const SettingsNotificationsRoute = SettingsNotificationsRouteImport.update({
            id: '/notifications',path: '/notifications',getParentRoute: () => SettingsRoute
          })
const SettingsEarningsRoute = SettingsEarningsRouteImport.update({
            id: '/earnings',path: '/earnings',getParentRoute: () => SettingsRoute
          })
const SettingsDashboardRoute = SettingsDashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => SettingsRoute
          })
const SettingsBillingHistoryRoute = SettingsBillingHistoryRouteImport.update({
            id: '/billing-history',path: '/billing-history',getParentRoute: () => SettingsRoute
          })
const SettingsBattlesRoute = SettingsBattlesRouteImport.update({
            id: '/battles',path: '/battles',getParentRoute: () => SettingsRoute
          })
const BattleIdBidsRoute = BattleIdBidsRouteImport.update({
            id: '/battle_/$id/bids',path: '/battle/$id/bids',getParentRoute: () => rootRouteImport
          })
const BattleIdDetailsRoute = BattleIdDetailsRouteImport.update({
            id: '/details',path: '/details',getParentRoute: () => BattleIdRoute
          })
const BattleIdBattleRoute = BattleIdBattleRouteImport.update({
            id: '/battle',path: '/battle',getParentRoute: () => BattleIdRoute
          })
const SettingsNotificationsPreferencesRoute = SettingsNotificationsPreferencesRouteImport.update({
            id: '/notifications_/preferences',path: '/notifications/preferences',getParentRoute: () => SettingsRoute
          })





const SettingsRouteChildren = {
  SettingsBattlesRoute: SettingsBattlesRoute,SettingsBillingHistoryRoute: SettingsBillingHistoryRoute,SettingsDashboardRoute: SettingsDashboardRoute,SettingsEarningsRoute: SettingsEarningsRoute,SettingsNotificationsRoute: SettingsNotificationsRoute,SettingsPasswordRoute: SettingsPasswordRoute,SettingsProfileRoute: SettingsProfileRoute,SettingsNotificationsPreferencesRoute: SettingsNotificationsPreferencesRoute
}

const SettingsRouteWithChildren = SettingsRoute._addFileChildren(SettingsRouteChildren)




const BattleIdRouteChildren = {
  BattleIdBattleRoute: BattleIdBattleRoute,BattleIdDetailsRoute: BattleIdDetailsRoute
}

const BattleIdRouteWithChildren = BattleIdRoute._addFileChildren(BattleIdRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AboutRoute: AboutRoute,AccountTypesRoute: AccountTypesRoute,BattlesRoute: BattlesRoute,DevboxRoute: DevboxRoute,HelpCenterRoute: HelpCenterRoute,HistoryRoute: HistoryRoute,HowItWorksRoute: HowItWorksRoute,SettingsRoute: SettingsRouteWithChildren,TermsRoute: TermsRoute,AuthLoginRoute: AuthLoginRoute,AuthResetPasswordRoute: AuthResetPasswordRoute,AuthSignupRoute: AuthSignupRoute,BattleIdRoute: BattleIdRouteWithChildren,CallbacksPaymentRoute: CallbacksPaymentRoute,BattleIdBidsRoute: BattleIdBidsRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)